exports.countryDefinition = {
  country: 'Belize',
  code: 'BZ',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 }
  },
  viewFormat: [['company'], ['address'], ['address2'], ['city']],
  formFormat: [['company'], ['address'], ['address2'], ['city']],
  requiredFormFields: [{ field: 'address' }, { field: 'city' }]
};
